import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import clsx from 'clsx';
import { Icon } from '@/components';
import { useOpenEditor } from '@/hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FrameHeader = ({
  frame,
  isCompile = true,
  showOriginal,
  hasFragment,
  onToggle
}) => {
  const {
    isLoading,
    openEditor
  } = useOpenEditor();
  const fileUriParts = (showOriginal || isCompile ? [frame.getPrettyOriginalFileUri(), frame.orgLine, frame.orgColumn] : [frame.fileName, frame.line, frame.column]).filter(Boolean);
  return /*#__PURE__*/_jsxs("div", {
    className: "ima-frame-header",
    children: [/*#__PURE__*/_jsx("div", {
      className: "ima-frame-header__tab",
      children: /*#__PURE__*/_jsxs("div", {
        className: "ima-frame-header__file-info",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "ima-frame-header__method-name",
          children: [!hasFragment && /*#__PURE__*/_jsx(Icon, {
            icon: "alert",
            size: "xs",
            className: "ima-frame-header__error-icon"
          }), isCompile ? frame.getPrettyFileName() : frame.getFunctionName()]
        }), fileUriParts.length > 0 && /*#__PURE__*/_jsx("div", {
          className: "ima-frame-header__file-uri",
          children: fileUriParts.join(':')
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "ima-frame-header__actions",
      children: [!isCompile && /*#__PURE__*/_jsx("button", {
        type: "button",
        className: clsx('ima-frame-header__button', {
          'ima-frame-header__button--green': showOriginal
        }),
        onClick: () => onToggle(),
        children: showOriginal ? /*#__PURE__*/_jsx(Icon, {
          icon: "openEye"
        }) : /*#__PURE__*/_jsx(Icon, {
          icon: "closedEye"
        })
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: clsx('ima-frame-header__button', {
          'ima-frame-header__button--pulse': isLoading
        }),
        onClick: () => openEditor(frame, showOriginal),
        disabled: isLoading,
        color: "light",
        children: /*#__PURE__*/_jsx(Icon, {
          size: "md",
          icon: "edit"
        })
      })]
    })]
  });
};
export default FrameHeader;